import React from 'react';

const ShopDetailsSkeleton = () => {
  return (
    <section className="shop-details-area pt-110 pb-50">
      <div className="container">
        <div className="shop-details-wrap">
          <div className="row">
            {/* Left Column: Images */}
            <div className="col-lg-7 col-md-6">
              <div className="shop-details-img-wrap">
                <div className="shop-details-img skeleton shop-details-skeleton-img"></div>
              </div>
              <div className="shop-details-nav-wrap">
                <div className="shop-details-skeleton-thumbs">
                  {[1, 2, 3, 4].map((i) => (
                    <div key={i} className="skeleton shop-details-skeleton-thumb"></div>
                  ))}
                </div>
              </div>
            </div>

            {/* Right Column: Content */}
            <div className="col-lg-5 col-md-6">
              <div className="shop-details-content shop-details-skeleton-content">
                {/* Collection Name */}
                <div className="skeleton skeleton-text" style={{ width: '30%' }}></div>
                
                {/* Product Title */}
                <div className="skeleton skeleton-title"></div>

                {/* Price */}
                <div className="skeleton shop-details-skeleton-price"></div>

                {/* Description */}
                <div className="skeleton skeleton-text"></div>
                <div className="skeleton skeleton-text"></div>
                <div className="skeleton skeleton-text" style={{ width: '80%' }}></div>

                {/* Size Selector */}
                <div className="shop-details-dimension mt-4">
                  <div className="skeleton skeleton-text" style={{ width: '50px', marginBottom: '10px' }}></div>
                  <div className="d-flex gap-2">
                    {[1, 2, 3].map((i) => (
                      <div key={i} className="skeleton" style={{ width: '40px', height: '40px', marginRight: '10px' }}></div>
                    ))}
                  </div>
                </div>

                {/* Color Selector */}
                <div className="shop-details-color mt-4">
                  <div className="skeleton skeleton-text" style={{ width: '50px', marginBottom: '10px' }}></div>
                  <div className="d-flex gap-2">
                    {[1, 2, 3, 4].map((i) => (
                      <div key={i} className="skeleton skeleton-circle" style={{ width: '30px', height: '30px', marginRight: '10px' }}></div>
                    ))}
                  </div>
                </div>

                {/* Quantity and Add to Cart */}
                <div className="shop-details-quantity mt-4">
                  <div className="skeleton skeleton-text" style={{ width: '80px', marginBottom: '10px' }}></div>
                  <div className="d-flex align-items-center">
                    <div className="skeleton" style={{ width: '120px', height: '50px', marginRight: '20px' }}></div>
                    <div className="skeleton skeleton-btn"></div>
                  </div>
                </div>

                {/* Meta Info */}
                <div className="shop-details-bottom shop-details-skeleton-meta">
                  <div className="skeleton shop-details-skeleton-meta-item"></div>
                  <div className="skeleton shop-details-skeleton-meta-item"></div>
                  <div className="skeleton shop-details-skeleton-meta-item"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShopDetailsSkeleton;
